import styled from 'styled-components'

import theme from 'theme'

const FullscreenTakeover = styled.div<{ innerHeight?: number }>`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  height: ${(props) => props.innerHeight || '100vh'};
  @media screen and (max-width: ${theme.breakpoints.md - 1}px) {
    position: fixed;
    bottom: 0;
    overflow-y: auto;
  }

  @supports (-webkit-overflow-scrolling: touch) {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  @media screen and (max-width: ${theme.breakpoints.md - 1}px) {
    box-shadow: none;
    margin-bottom: 0;
  }

  @media screen and (max-width: ${theme.breakpoints.sm - 1}px) {
    padding-top: env(safe-area-inset-top, 50px);
    padding-right: env(safe-area-inset-right, 50px);
    padding-bottom: env(safe-area-inset-bottom, 50px);
    padding-left: env(safe-area-inset-left, 50px);
  }
`

export default FullscreenTakeover
